export class DateDisplay {
    public day: string;
    public date: number;
    public flag: boolean;
    public disableTimeSheetEntry: boolean;
    public total: number;
    constructor(data: any = {}) {
        this.day = data.day || '';
        this.date = data.date || null;
        this.flag = data.flag || true;
        this.disableTimeSheetEntry = data.disableTimeSheetEntry || false;
        this.total = data.total || 0;
    }
}


// WEBPACK FOOTER //
// ./src/app/common/leave-pop-up/leave-pop-up.interface.ts